const headers = {
  name: "Setting Tax Types",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search tax types...",
      value: "",
      allowClear: true,
    },
    {
      type: "select",
      name: "status",
      placeholder: "Status",
      value: null,
      options: [
        { value: "true", label: "Active" },
        { value: "false", label: "Inactive" },
      ],
      allowClear: true,
    },
    {
      type: "add",
      path: "/app/settings/tax/types/add",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Settings",
        path: "/app/settings",
      },
      {
        name: "Taxes",
        path: "/app/settings/tax",
      },
      {
        name: "Tax Types",
        path: "",
      },
    ],
    total: [
      { value: "0", label: "Total" },
      { value: "0", label: "Active" },
      { value: "0", label: "Inactive" },
    ],
  },
};

export default headers;